import React, { Component } from 'react';
import { connect } from "react-redux";

import { Button, Col } from 'react-bootstrap';

class ContactButton extends Component {
    render() {
        let buttonText;
        switch (this.props.language) {
            case 'English':
                buttonText = 'Contact'
                break
            default:
                buttonText = 'Kontakt'
        }

        return (
            <Col md={2}>
                <Button
                    bsStyle="default"
                    block
                    onClick={() => this.props.updateScreen('Contact')}
                >
                    {buttonText}
                </Button>
            </Col>
        );
    }
}

const mapStateToProps = state => {
    return { language: state.language };
};

const mapDispatchToProps = dispatch => {
    return {
        updateScreen: screen => dispatch({ type: 'UPDATE_SCREEN', payload: screen })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactButton);


// WEBPACK FOOTER //
// ./src/screens/buttons/ContactButton.js